<div class="content space-y-4">

    <div class="flex justify-between items-center">
        <div class="flex items-center gap-2 text-lg font-semibold text-primary-500">
            <fa-icon [icon]="faChartLine" class="text-primary-500 text-xl"></fa-icon>
            <span>การวิเคราะห์ข้อมูลการขาย</span>
            <span class="label !text-xs"
                [ngClass]="branchMode ? 'label-primary' : 'label-secondary'">
                {{ branchMode ? 'สาขา' : 'สำนักงานใหญ่' }}
            </span>
        </div>
    </div>

    <div class="w-full text-base font-medium text-center text-gray-500 border-b border-gray-200">
        <div class="w-full md:w-fit flex flex-wrap -mb-px">
            <button class="flex-1 me-2" (click)="state='sale'">
                <p [ngClass]="{'text-black font-semibold border-primary-500':state==='sale' , 'border-transparent hover:text-gray-600 hover:border-gray-300':state!=='sale'}"
                    class="inline-block whitespace-nowrap p-4 border-b-2 rounded-t-lg">
                    ยอดขาย</p>
            </button>
            <button class="flex-1 me-2" (click)="state='product-overview'">
                <p [ngClass]="{'text-black font-semibold border-primary-500':state==='product-overview' , 'border-transparent hover:text-gray-600 hover:border-gray-300':state!=='product-overview'}"
                    class="inline-block whitespace-nowrap p-4 border-b-2 rounded-t-lg">
                    ภาพรวมสินค้า</p>
            </button>
            <button class="flex-1 me-2" (click)="state='product'">
                <p [ngClass]="{'text-black font-semibold border-primary-500':state==='product' , 'border-transparent hover:text-gray-600 hover:border-gray-300':state!=='product'}"
                    class="inline-block whitespace-nowrap p-4 border-b-2 rounded-t-lg">
                    สินค้า</p>
            </button>
            @if(!branchMode){
            <button class="flex-1 me-2" (click)="state='product-set'">
                <p [ngClass]="{'text-black font-semibold border-primary-500':state==='product-set' , 'border-transparent hover:text-gray-600 hover:border-gray-300':state!=='product-set'}"
                    class="inline-block whitespace-nowrap p-4 border-b-2 rounded-t-lg">
                    เซ็ตสินค้า</p>
            </button>
            }
            @if(branchMode){
            <button class="flex-1 me-2" (click)="state='restock'">
                <p [ngClass]="{'text-black font-semibold border-primary-500':state==='restock' , 'border-transparent hover:text-gray-600 hover:border-gray-300':state!=='restock'}"
                    class="inline-block whitespace-nowrap p-4 border-b-2 rounded-t-lg">
                    เติมสต๊อกสินค้า</p>
            </button>
            }
        </div>
    </div>

    @if(state==='sale'){
    <app-data-analysis-sale [branchMode]="branchMode"></app-data-analysis-sale>
    }
    @if(state==='product-overview'){
    <app-data-analysis-product-overview [branchMode]="branchMode"></app-data-analysis-product-overview>
    }
    @if(state==='product'){
    <app-data-analysis-product [branchMode]="branchMode"></app-data-analysis-product>
    }
    @if(state==='product-set'){
        <app-data-analysis-product-set [branchMode]="branchMode"></app-data-analysis-product-set>
    }
    @if(state==='restock'){
    <app-data-analysis-restock></app-data-analysis-restock>
    }

</div>

